import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import FirstTimePasswordReset from '@/components/FirstTimePasswordReset';

const FirstTimePasswordResetPage: React.FC = () => {
  const { user, isAuthenticated, isFirstTimeLogin, completeFirstTimeLogin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If not authenticated, redirect to login
    if (!isAuthenticated || !user) {
      navigate('/login', { replace: true });
      return;
    }

    // If not a first-time login, redirect to dashboard
    if (!isFirstTimeLogin) {
      navigate('/', { replace: true });
      return;
    }
  }, [isAuthenticated, user, isFirstTimeLogin, navigate]);

  // Show loading or nothing while redirecting
  if (!isAuthenticated || !user || !isFirstTimeLogin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <FirstTimePasswordReset
      user={user}
      onPasswordChanged={completeFirstTimeLogin}
    />
  );
};

export default FirstTimePasswordResetPage;
